import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ReactComponent as VerifyEmailIcon } from "../../../../assets/SelfReg-VerifyEmailIcon.svg";
import { getSupportLink } from "../../../../Helpers";

const offsetStyle = "72px";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    height: "100%",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      height: `calc(100vh - ${offsetStyle})`,
      minHeight: `calc(100vh - ${offsetStyle})`,
    },
  },
  headerIcon: {
    marginTop: "4rem",
  },
  subHeader: {
    fontSize: 16,
    marginTop: "1rem",
    marginBottom: "2.5rem",
    maxWidth: 582,
  },
  link: {
    textDecoration: "underline",
    color: "inherit",
    cursor: "pointer",
    background: "none",
    border: "none",
  },
}));

const opaqueStyle = {
  backgroundColor: "#fafafa",
  color: "#000000E6",
};

interface VerifyEmailProps {
  email: string;

  children?: any;
}

export const VerifyEmail = (props: VerifyEmailProps) => {
  const classes = useStyles();
  let { email, children } = props;
  return (
    <div className={classes.container} style={opaqueStyle}>
      <div className={classes.headerIcon}>{<VerifyEmailIcon />}</div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}>
        <Typography
          component="span"
          variant="h3"
          sx={{
            fontWeight: "bold",
            fontSize: 30,
            marginTop: "3rem",
            alignItem: "left",
            minWidth: "582px",
          }}>
          Please verify your email
        </Typography>
      </Box>
      <Typography
        component="main"
        className={classes.subHeader}
        variant={"body1"}
        sx={{ fontWeight: 400 }}>
        <>
          The email you provided during sign up was{" "}
          <a
            style={{ color: "primary" }}
            className={classes.link}
            href={`mailto:${email}`}>
            {email}
          </a>
          . If this is correct, please check your inbox or spam folder for a verification
          email. If the email you entered is not correct, please reach out to us{" "}
          <a
            className={classes.link}
            href={getSupportLink(false)}
            target="_blank"
            rel="noopener noreferrer">
            here
          </a>
          .
        </>
      </Typography>
      {children}
    </div>
  );
};
